import React, { useState } from "react";
import './index.scss';
import SectionHeader from "../SectionHeader";
import { ROUTE_PATH, CREDIT_PRODUCT_TYPE } from "@/utils/Global";
import i18n from "@/i18n";
import FunctionCard from "../FunctionCard";
import DataStorage from "@/utils/DataManager/DataStorage";

const UrlToVideoSection = ({ history }) => {
    const urlToVideoDatas = [
        DataStorage.GetURLToVideoData(CREDIT_PRODUCT_TYPE.YOUTUBE_URL_TO_VIDEO),
        DataStorage.GetURLToVideoData(CREDIT_PRODUCT_TYPE.PRODUCT_URL_TO_VIDEO),
    ].filter(item => item !== undefined)

    const handleClickItem = (routePath) => {
        history.push(routePath)
    }

    return (
        <div className="url-to-video-section-wrapper">
            <SectionHeader title="URL to Video" descriptions={[i18n.t("web.pc.landing.2025.url.to.shorts.header.des")]}
                onClickButton={() => handleClickItem(ROUTE_PATH.YOUTUBE_SHORTS)}
                // isComingSoon={true}
            />
            <div className="url-to-video-section-content">
                {
                    urlToVideoDatas.map((item) => (
                        <FunctionCard {...item} />
                    ))
                }
            </div>
        </div>
    )
}

export default UrlToVideoSection;